import { render, staticRenderFns } from "./minbasketvalue.vue?vue&type=template&id=92c20350&"
import script from "./minbasketvalue.vue?vue&type=script&lang=js&"
export * from "./minbasketvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/83/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92c20350')) {
      api.createRecord('92c20350', component.options)
    } else {
      api.reload('92c20350', component.options)
    }
    module.hot.accept("./minbasketvalue.vue?vue&type=template&id=92c20350&", function () {
      api.rerender('92c20350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/minbasketvalue.vue"
export default component.exports